import axios from 'axios';

// In dev mode, Vite proxy forwards /api to localhost:8080.
// In production, set VITE_API_URL to the backend origin.
const BASE_URL = import.meta.env.VITE_API_URL ?? '';

// --- Debug mode (no Firebase) ---
let debugUid = 'demo-player';

export function setDebugUid(uid: string) {
  debugUid = uid;
}

export function getDebugUid(): string {
  return debugUid;
}

// --- Token provider (set by AuthProvider when Firebase is active) ---
type TokenProvider = () => Promise<string>;
let tokenProvider: TokenProvider | null = null;

export function setTokenProvider(provider: TokenProvider) {
  tokenProvider = provider;
}

const api = axios.create({ baseURL: BASE_URL });

api.interceptors.request.use(async (config) => {
  config.headers['Content-Type'] = 'application/json';

  if (tokenProvider) {
    const token = await tokenProvider();
    if (token) {
      // Real Firebase ID token
      config.headers['Authorization'] = `Bearer ${token}`;
      return config;
    }
    // Token provider is set but returned empty — user is signed out; do not fall through to debug auth
    throw new axios.Cancel('Not authenticated — sign in required');
  }

  // Fallback: debug UID — only in dev mode (Vite injects import.meta.env.DEV)
  if (import.meta.env.DEV) {
    config.headers['Authorization'] = `Bearer ${debugUid}`;
    return config;
  }

  // In production with no token provider, do not send any auth header
  throw new axios.Cancel('Not authenticated — sign in required');
});

export default api;
